import { userConstants } from '../constants'
import { clientConstants } from '../constants/client.constants'

const initialState = {
	balancePoints: null,
	expiringPoints: null,
	clientPointsWasLoaded: false,
	availablePointsToBuy: null
}

export default function clientReducer(state = initialState, { type, payload }) {
	switch (type) {
		case userConstants.LOGOUT:
			return Object.assign({}, initialState)
		case clientConstants.LOADING_POINTS:
			return { ...state, clientPointsWasLoaded: false }
		case clientConstants.POINTS_WAS_LOADED:
			return { ...state, clientPointsWasLoaded: true }
		case clientConstants.GET_BALANCE_POINTS:
			return { ...state, balancePoints: payload }
		case clientConstants.GET_EXPIRING_POINTS:
			return { ...state, expiringPoints: payload }
		case clientConstants.GET_ABAILABLE_POINTS_TO_BUY:
			return { ...state, availablePointsToBuy: payload }
		default:
			return state
	}
}
